const config = {
    ABDIEL_BACKEND: process.env.REACT_APP_ABDIEL_BACKEND,
    GOOGLE_API: process.env.REACT_APP_GOOGLE_API,
    GOOGLE_API_KEY: process.env.REACT_APP_GOOGLE_API_KEY,
    REACT_APP_JWT_SECRET_KEY: process.env.REACT_APP_JWT_SECRET_KEY,
    REACT_APP_JWT_ALG: process.env.REACT_APP_JWT_ALG,
    REACT_APP_WEB_SOCKET: process.env.REACT_APP_WEB_SOCKET,
    REACT_APP_BACKEND: process.env.REACT_APP_BACKEND,
    REACT_APP_CRYPTO_ALG: process.env.REACT_APP_CRYPTO_ALG
}

export default config